import Component from '../core/Component'
import PF from 'pathfinding'
import { createGridOverlay } from '../plugins/GridOverlay'

export const EMITS = {

}

export default class ConnectLine extends Component {
    constructor($element) {
        super($element)

        this.options = {
            color: '#000',
            density: 1,
            gridExpand: 0,
            showOnInit: true
        }
        if (this.element.dataset.options) {
            this.options = {
                ...this.options,
                ...JSON.parse(this.element.dataset.options)
            }
        }

        this.svg = null
        this.timer = null
    }

    prepare() {
        this.createSvg()
        this.appendSvg()

        window.addEventListener('resize', this.handleResize)
    }

    destroy() {
        window.removeEventListener('resize', this.handleResize)
        this.clearSvg()
    }

    handleResize = () => {
        this.clearSvg()
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.createSvg()
            this.appendSvg()
        }, 1000)
    }

    clearSvg() {
        const svg = this.svg
        if (svg) {
            svg.parentNode.removeChild(svg)
            this.svg = null
        }
    }

    appendSvg() {
        const svg = this.svg

        const path = svg.querySelector('path')
        if (path) {
            const length = path.getTotalLength()
            path.style.strokeDashoffset = `${length}px`
            path.style.strokeDasharray = `${length}px`
            path.style.transition = `1s stroke-dashoffset .2s`
        }

        if (this.options.showOnInit) {
            this.showSvg()
        }

        document.body.appendChild(svg)
    }

    showSvg() {
        this.options.showOnInit = true
        if (!this.svg) {
            return
        }
        const path = this.svg.querySelector('path')
        if (!path) {
            return
        }
        path.style.strokeDashoffset = `0px`
    }

    createSvg() {
        this.clearSvg()

        const gridOverlay = createGridOverlay({
            baseObjects: [
                { query: this.options.start, walkable: true },
                { query: this.options.end, walkable: true },
                ...this.options.excluded
            ],
            // density: 1,
            gridExpand: 10
        })

        const start = gridOverlay.objects[0]
        const end = gridOverlay.objects[1]

        const pfGrid = new PF.Grid(gridOverlay.grid)
        const finder = new PF.BiBreadthFirstFinder()
        const coordsFull = finder.findPath(start.normPos.x, start.normPos.y, end.normPos.x, end.normPos.y, pfGrid)
        const coords = PF.Util.compressPath(coordsFull)

        const svg = this.createSvgPath(gridOverlay, coords)
        this.svg = svg
        return svg
    }

    createSvgPath(gridOverlay, coords) {
        const xmlns = "http://www.w3.org/2000/svg"
        const svg = document.createElementNS(xmlns, "svg")
        svg.setAttributeNS(null, "viewBox", `0 0 ${gridOverlay.normMeta.width} ${gridOverlay.normMeta.height}`)
        const path = document.createElementNS(xmlns, "path");
        path.setAttributeNS(null, 'd', getSvgPathFromCoords(coords))
        path.setAttributeNS(null, 'fill', "none");
        path.setAttributeNS(null, 'stroke', this.options.color);
        path.setAttributeNS(null, 'stroke-width', 1);
        path.setAttributeNS(null, 'shape-rendering', 'crispEdges');
        svg.appendChild(path)
        svg.style.position = `absolute`
        svg.style.zIndex = `2`
        svg.style.top = `${gridOverlay.gridMeta.y - 1}px`
        svg.style.left = `${gridOverlay.gridMeta.x - 1}px`
        svg.style.width = `${gridOverlay.gridMeta.width}px`
        svg.style.height = `${gridOverlay.gridMeta.height}px`
        svg.style.pointerEvents = `none`
        return svg
    }
}


//kazdy coord ma +1px
function getSvgPathFromCoords(coords) {
    let d = ''
    coords.forEach(coord => {
        d += d === "" ? "M" : " L"
        d += `${coord[0] + 1}, ${coord[1] + 1}`
    })
    return d
}




// WEBPACK FOOTER //
// ./components/ConnectLine.js